var render = function (_h,_vm) {var _c=_vm._c;return _c('tr',[_c('th',{class:{ tall: _vm.props.tall }},[_vm._v(_vm._s(_vm.props.rank))]),_c('td',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.props.name))]),_c('span',[_vm._v(_vm._s(_vm.props.score))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }